<!--
 * @Description: 试题库 查看
 * @Author: PF
 * @Date: 2022-09-23 11:53:38
 * @LastEditors: PF
 * @LastEditTime: 2025-11-24 11:14:11
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Document /></el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="试题库" label-align="right" align="left" width="120px" span="2" >{{ruleForm.zystkmc}}</el-descriptions-item>
        <el-descriptions-item label="课程" label-align="right" align="left" width="120px" span="2" >{{ruleForm.zystkstsyjxdymc}}</el-descriptions-item>
        <el-descriptions-item label="适用类型" label-align="right" align="left" width="120px" span="2" >
          <span v-if="ruleForm.sylx=='1'">考试</span>
          <span v-if="ruleForm.sylx=='2'">作业</span>
        </el-descriptions-item>
        <el-descriptions-item label="学期数" label-align="right" align="left" span="2" >{{ruleForm.xqsmc}}</el-descriptions-item>
        <el-descriptions-item label="题型" label-align="right" align="left" span="2" >{{ ruleForm.zystksttxmc }}</el-descriptions-item>
        <el-descriptions-item label="教学单元" label-align="right" align="left" span="2" >{{ruleForm.zystkstsyjxdymc}}</el-descriptions-item>
        <el-descriptions-item label="教学内容" label-align="right" align="left" span="2" >{{ ruleForm.zystkstsyjxnrmc }}</el-descriptions-item>
        <el-descriptions-item label="难度" label-align="right" align="left" span="2" >{{ ruleForm.zystkstnd }}</el-descriptions-item>
        <el-descriptions-item label="区分度" label-align="right" align="left" span="2" >{{ ruleForm.zystkstqfd }}</el-descriptions-item>
        <el-descriptions-item label="考试要求" label-align="right" align="left" span="4" >
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstksyq"></p>
        </el-descriptions-item>
        <el-descriptions-item label="试题正文" label-align="right" align="left" span="4" >
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstzw"></p>
        </el-descriptions-item>
        <el-descriptions-item v-if="ruleForm.zystksttx === zytxData.danXuan || ruleForm.zystksttx === zytxData.duoXuan" label="参考选项" label-align="right" align="left" span="4" >
          <div class="wp100">
            <el-table class="mt10" :data="ruleForm.cankaolist" style="width: 100%" border :show-header="false">
              <el-table-column align="left" width="80" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.xxbh }}
                </template>
              </el-table-column>
              <el-table-column align="left" show-overflow-tooltip>
                <template #default="scope">
                  <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.xxnr"></p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-descriptions-item>
        <el-descriptions-item v-if="ruleForm.zystksttx === zytxData.panDuan" label="答案" label-align="right" align="left" span="4" >
          <span v-if="ruleForm.zystkstksda === true">对</span>
          <span v-if="ruleForm.zystkstksda === false">错</span>
        </el-descriptions-item>
        <el-descriptions-item v-else-if="ruleForm.zystksttx === zytxData.tianKong" label="答案" label-align="right" align="left" span="4">
          <el-table class="mt10" :data="ruleForm.tktckda" style="width: 100%" border :show-header="false">
            <el-table-column align="left" show-overflow-tooltip>
              <template #default="scope">
                <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.tktckda"></p>
              </template>
            </el-table-column>
          </el-table>
        </el-descriptions-item>
        <el-descriptions-item v-else label="答案" label-align="right" align="left" span="4" >
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstksda"></p>
        </el-descriptions-item>
        <el-descriptions-item label="解析" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstjx"></p>
        </el-descriptions-item>
        <el-descriptions-item label="评分标准" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstpfbz"></p>
        </el-descriptions-item>
        <el-descriptions-item label="建议考试得分" label-align="right" align="left" span="2" >{{ ruleForm.zystkstjyksdf }}</el-descriptions-item>
        <el-descriptions-item label="保密度" label-align="right" align="left" span="2" >{{ ruleForm.zystkstbmdmc }}</el-descriptions-item>
        <el-descriptions-item label="审核状态" label-align="right" align="left" span="2" >
          <span v-if="ruleForm.zystkstshtjzt === true">已审核</span>
          <span v-if="ruleForm.zystkstshtjzt === false">未审核</span>
        </el-descriptions-item>
        <el-descriptions-item label="审核结果" label-align="right" align="left" span="2" >
          <span v-if="ruleForm.zystkstshjg === 2">已通过</span>
          <span v-if="ruleForm.zystkstshjg === 1">未通过</span>
          <span v-if="ruleForm.zystkstshjg === 0">未审核</span>
        </el-descriptions-item>
        <el-descriptions-item label="审核意见" label-align="right" align="left" span="4" >
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.zystkstshyj"></p>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import { getTiXing } from '@/utils/zidianmeiju'
import { toChinesNum } from '@/utils/index.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openDetail'])

const ruleForm = ref({})

const zytxData = ref({ list: [] })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      zytxData.value = getTiXing()
      loadData({
        url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti/' + props.row.id,
        ruleForm: ruleForm,
        loadSuccess: function (res) {
          ruleForm.value = res.data
          ruleForm.value.xqsmc = '第' + toChinesNum(Number(res.data.xqmc)) + '学期'
          if (ruleForm.value.zystksttx === zytxData.value.panDuan) {
            // 判断题参考答案
            ruleForm.value.zystkstksda = Boolean(res.data.zystkstksda) || null
          } else if (ruleForm.value.zystksttx === zytxData.value.tianKong) {
            // 填空题参考答案
            ruleForm.value.tktckda = res.data.tktckda.map(item => ({ tktckda: item }))
          }
        }
      })
    }
  }, { deep: true, immediate: true })
</script>
